import { Badge } from "design-system/atoms/Badge"
import { cn } from "design-system/utils"
import { RotateCcw } from "lucide-react"
import { useTranslation } from "react-i18next"
import { IssueStatusEnum } from "schema"

type Props = {
  issue: {
    status: (typeof IssueStatusEnum)[number]
  }
  className?: string
}

export function IssueReopenedBadge({ issue, className }: Props) {
  const { t } = useTranslation()

  if (issue.status !== "Reopened") return null

  return (
    <Badge
      variant="outline"
      className={cn("shrink-0 border-current text-support-primary", className)}
    >
      <RotateCcw size={14} />
      <span>{t("support.entities.issueStatus.Reopened")}</span>
    </Badge>
  )
}
